module.exports = __webpack_public_path__ + "static/img/QuarterAcre.471c1a08.jpeg";